"use client";
import { Box, Container, Grid2, useMediaQuery } from "@mui/material";
import Image from "next/image";

export default function HavanAwardSection({ variant = "home" }: { variant?: "home" | "about" }) {
    const isMobile = useMediaQuery("(max-width:900px)");

    if (variant === "home") {
        return (
            <Box
                sx={{
                    backgroundColor: "rgb(215, 210, 193)",
                    padding: { xs: "2rem 0", md: "4rem 0" },
                }}
            >
                <Container>
                    <Grid2 container spacing={4} alignItems="center">
                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <Box
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    aspectRatio: { xs: "1.9 / 1", md: "1.9 / 1" },
                                }}
                            >
                                <Image
                                    src="/havan-finalist/HA26_ForFinalists_V2-1200x630.jpg"
                                    alt="HAVAN Award Finalist 2026"
                                    fill
                                    style={{
                                        objectFit: "cover",
                                    }}
                                />
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: isMobile ? "center" : "flex-start",
                                    textAlign: isMobile ? "center" : "left",
                                }}
                            >
                                <h2
                                    style={{
                                        fontSize: isMobile ? "32px" : "56px",
                                        fontWeight: "normal",
                                        margin: 0,
                                        marginBottom: "1rem",
                                    }}
                                >
                                    HAVAN Award Finalist 2026
                                </h2>
                                <p
                                    className="mono_font"
                                    style={{ color: "black", fontWeight: 500 }}
                                >
                                    Recognizing Excellence in Housing
                                </p>
                                <p
                                    style={{
                                        fontSize: "1.125rem",
                                        marginTop: "1rem",
                                        marginBottom: 0,
                                    }}
                                >
                                    We are honored to be named a finalist in the 2026 HAVAN Awards 
                                    for Housing Excellence, recognizing outstanding achievement in 
                                    new home construction and design in Metro Vancouver.
                                </p>
                            </Box>
                        </Grid2>
                    </Grid2>
                </Container>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                backgroundColor: "white",
                padding: { xs: "2rem 0", md: "4rem 0" },
            }}
        >
            <Container>
                <Grid2 container spacing={6} alignItems="center">
                    <Grid2 size={{ xs: 12, md: 5 }}>
                        <Box
                            sx={{
                                position: "relative",
                                width: { xs: "80%", md: "100%" },
                                marginX: { xs: "auto", md: 0 },
                                aspectRatio: "1080/1350",
                            }}
                        >
                            <Image
                                src="/havan-finalist/HA26_ForFinalists_V2-1080x1350.jpg"
                                alt="HAVAN Award Finalist 2026"
                                fill
                                style={{
                                    objectFit: "cover",
                                }}
                            />
                        </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 7 }}>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: isMobile ? "center" : "flex-start",
                                textAlign: isMobile ? "center" : "left",
                            }}
                        >
                            <p
                                className="mono_font"
                                style={{ color: "black", fontWeight: 500 }}
                            >
                                AWARD RECOGNITION
                            </p>
                            <h2
                                style={{
                                    fontSize: isMobile ? "36px" : "48px",
                                    fontWeight: "normal",
                                    margin: 0,
                                    marginBottom: "1.5rem",
                                }}
                            >
                                HAVAN Award Finalist 2026
                            </h2>
                            <p
                                style={{
                                    fontSize: "1.125rem",
                                    lineHeight: "1.6",
                                    marginBottom: 0,
                                }}
                            >
                                Medallion Homes has been selected as a finalist for the 2026 HAVAN Awards 
                                for Housing Excellence. This prestigious recognition celebrates the finest 
                                in home building, renovation, and design throughout Metro Vancouver. 
                                Being named a finalist reflects our unwavering commitment to quality 
                                craftsmanship, innovative design, and exceptional client service in every 
                                project we undertake.
                            </p>
                        </Box>
                    </Grid2>
                </Grid2>
            </Container>
        </Box>
    );
}
